import { createRequest } from "helpers/tools";

export const createSource = async (form) => {
    return await createRequest({
        suffix: "sources",
        method: "post",
        payload: form,
        handleError: false,
    });
};
export const sftpSource = async (form) => {
    return await createRequest({
        suffix: "sources/sftp-connect",
        method: "post",
        payload: form,
        handleError: false,
    });
};
export const sftpFileReadingSource = async (form) => {
    return await createRequest({
        suffix: "sources/read-file",
        method: "post",
        payload: form,
        handleError: false,
    });
};
export const addSourceToTracker = async (source_id, tracker_id) => {
    return await createRequest({
        suffix: `trackers/${tracker_id}/sources`,
        method: "post",
        payload: source_id,
        handleError: false,
    });
};
export const fileUploadSource = async (form, id) => {
    return await createRequest({
        suffix: id ? `sources/file-upload/${id}` : `sources/file-upload`,
        method: "post",
        payload: form,
        handleError: false,
    });
};
export const getSourceZoho = async () => {
    return await createRequest({
        suffix: "zoho/modules",
        method: "get",
        handleError: false,
    });
};
export const getZohoAuthUrl = async (modules) => {
    return await createRequest({
        suffix: `zoho/auth-url?scope=source&module=${modules}`,
        handleError: true,
        method: "get",
    });
};
export const getZohoReconnect = async (id) => {
    let modules = "contacts";
    return await createRequest({
        suffix: `zoho/auth-url?scope=source&module=${modules}&source_id=${id}`,
        method: "get",
        handleError: false,
    });
};
export const sendSourceZohoData = async (data) => {
    return await createRequest({
        suffix: "zoho/store",
        method: "post",
        payload: data,
        handleError: false,
    });
};

export const zohoLeadgenID = async (data, id) => {
    return await createRequest({
        suffix: `zoho/update/${id}`,
        method: "put",
        payload: data,
        handleError: false,
    });
};

export const hubSpotMappings = async (data, id) => {
    return await createRequest({
        suffix: `hub/update/${id}`,
        method: "put",
        payload: data,
        handleError: false,
    });
};

export const hubSpotHistory = async (id) => {
    return await createRequest({
        suffix: `events/history/${id}`,
        method: "get",
        handleError: false,
    });
};

export const ftpReconnect = async (id, data) => {
    return await createRequest({
        suffix: `sources/${id}/service-update`,
        method: "post",
        payload: data,
        handleError: false,
    });
};

export const usageSourceCode = async (code) => {
    return await createRequest({
        suffix: `get-usage-types/${code}`,
        method: "get",
        handleError: false,
    });
};

export const zohoMappingEditField = async (id) => {};

export const updateHubSpotSource = async (id) => {};

export const getAllSourceMapping = async (id) => {
    return await createRequest({
        suffix: `sources/${id}/mappings`,
        method: "get",
        handleError: false,
    });
};

export const sendAllSourceUpdate = async (data, id, type) => {
    let suffix = `sources/${id}/mappings`;
    if (type === "appsflyer") {
        suffix = `appsflyer/update/${id}`;
    } else if (type === "adjust") {
        suffix = `adjust/update/${id}`;
    }
    return await createRequest({
        suffix,
        method: "put",
        payload: data,
        handleError: false,
    });
};

export const getHubspotUrl = async (module = "") => {
    return await createRequest({
        suffix: `hub/auth-url?module=${module}`,
        handleError: true,
        method: "get",
    });
};

export const sendHubSporData = async (data) => {
    return await createRequest({
        suffix: "hub/store",
        method: "post",
        payload: data,
        handleError: false,
    });
};

export const sourceCreateCapi = async (data) => {
    return await createRequest({
        suffix: "sources/mobile-capi",
        method: "post",
        payload: data,
        handleError: false,
    });
};

export const getZohoTest = async (id) => {
    return await createRequest({
        suffix: `zoho/${id}/preview`,
        method: "get",
        handleError: false,
    });
};

export const getHubspotTest = async (id) => {
    return await createRequest({
        suffix: `hub/${id}/preview`,
        method: "get",
        handleError: false,
    });
};

export const getSourceMappingFields = async (id) => {
    return await createRequest({
        suffix: `sources/${id}/fields`,
        method: "get",
        handleError: false,
    });
};

export const getCrmSourceMappingFields = async (prefix, id) => {
    let suffix = `${prefix}/${id}/fields`;
    if (prefix === "pipe" || prefix === "lsqrd") {
        suffix = `sources/${prefix}/${id}/fields`;
    }
    return await createRequest({
        suffix,
        method: "get",
        handleError: false,
    });
};

export const sendCrmSourceUpdate = async (data, id, prefix) => {
    let suffix = `${prefix}/update/${id}`;
    if (prefix === "pipe" || prefix === "lsqrd") {
        suffix = `sources/${prefix}/update/${id}`;
    }
    return await createRequest({
        suffix,
        method: "put",
        payload: data,
        handleError: false,
    });
};
